import React, { useEffect, useState } from 'react';
import { api } from '../../routes/Users/user';
import { useNavigate } from 'react-router-dom';

const SESSION_KEY = 'authSession';
const SESSION_DURATION_MINUTES = 360; // 6 horas en minutos

type LoginFormProps = {
  onLogin: () => void;
};

const LoginForm: React.FC<LoginFormProps> = ({ onLogin }) => {
  const [correo, setCorreo] = useState('');
  const [contrasena, setContrasena] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [configuration, setConfiguration] = useState({ logo_primary_base64: '' });

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    setLoading(true);

    try {
      const response = await fetch(api + '/api/auth/login', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ correo, contrasena }),
      });

      const data = await response.json();
      if (!response.ok) {
        alert(data.message || 'Credenciales incorrectas');
        setLoading(false);
        return;
      }

      const expiresAt = Date.now() + 12 * 60 * 60 * 1000; // Cambié a 6 horas
      localStorage.setItem(
        'usuario',
        JSON.stringify({
          token: data.token,
          user: data.user,
        })
      );
      localStorage.setItem(
        SESSION_KEY,
        JSON.stringify({
          token: data.token,
          user: data.user,
          expiresAt,
        })
      );
      onLogin();
      navigate('/');
    } catch (error) {
      console.error('Error de login:', error);
      alert('Error al iniciar sesión');
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    const config = async () => {
      try {
        const response = await fetch(api + '/api/settings');
        const data = await response.json();

        setConfiguration(data);
      } catch (error) {
        console.error(error);
        return null;
      }
    }
    config();
  }, [])
  return (
    <div className="to-secondary-dark from-primary-light flex h-screen items-center justify-center bg-gradient-to-r">
      <div className="flex flex-col items-center justify-center">
        <img
          src={
            configuration.logo_primary_base64
              ? configuration.logo_primary_base64
              : '/logo_med.png'
          }
          alt="Logo"
          className="py-2"
          width={150}
        />
        <form
          className="w-full max-w-md rounded-lg border border-gray-100 bg-white p-8 shadow-lg"
          onSubmit={handleSubmit}
        >
          <div className="mb-6 flex flex-col items-center">
            <h2 className="text-3xl font-semibold text-gray-800">Iniciar sesión</h2>
          </div>

          <div className="mb-4">
            <label
              htmlFor="email"
              className="block text-sm font-medium text-gray-600"
            >
              Correo electrónico
            </label>
            <input
              id="email"
              type="email"
              placeholder="Correo electrónico"
              value={correo}
              onChange={e => setCorreo(e.target.value)}
              className="mt-2 w-full rounded-md border border-gray-300 p-3 shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
              required
            />
          </div>

          <div className="mb-6">
            <label
              htmlFor="password"
              className="block text-sm font-medium text-gray-600"
            >
              Contraseña
            </label>
            <input
              id="password"
              type="password"
              placeholder="Contraseña"
              value={contrasena}
              onChange={e => setContrasena(e.target.value)}
              className="mt-2 w-full rounded-md border border-gray-300 p-3 shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
              required
            />
          </div>

          <button
            type="submit"
            className="bg-primary-main hover:bg-primary-dark focus:ring-primary-dark w-full rounded-md p-3 text-lg font-semibold text-white transition-all focus:outline-none focus:ring-2"
            disabled={loading}
          >
            {loading ? 'Cargando...' : 'Iniciar sesión'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default LoginForm;
